package org.hs_soft.runmynesto.data.api_datasource.options.cash_flow

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient

import org.hs_soft.runmynesto.domain.model.home.options.cash_flow.app_config_model.AppConfigModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_flow.GetAppConfigRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.config.Errors

class GetAppConfigRepositoryImpl (
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
): GetAppConfigRepository
{
    override suspend fun getAppConfig(): AppConfigModel {

        val abortController = requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put(
                "query", """
                    query getAppConfig {
                      cashAssist {
                       	 getAppConfig { 
                           ${ApiUtils.Field.creditCards}
                      	   ${ApiUtils.Field.specialProductExpenses}
                         cashRegisterGlobal {
                                printerLocations {
                                  ${ApiUtils.Field.dbIndex}
                                  ${ApiUtils.Field.value}
                                  __typename
                                }
                                ${ApiUtils.Field.pointsSystemName}
                                ${ApiUtils.Field.isActivePointsSystem}
                                __typename
                              }
                              __typename
                            }
                        } 
                      
                    }
                """.trimIndent()
            )



        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }
    }

}
